import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';
import './login.js'
import './ui.js'

const CateTree = require('./bo/categoryManage/categoryTree');
window.cateTree = new CateTree();
window.cateTree.updateTreeData();
Vue.config.productionTip = false;
let vm = new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: {App}
});

//main.js里面的代码
router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面meta */
    let referrer = document.getElementById('referrer');
    if(to.meta.content){
        referrer.content = 'no-referrer';
    }else {
        referrer.content = "no-referrer-when-downgrade";
    }
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    next()
});





// WEBPACK FOOTER //
// ./src/main.js